<template>
  <v-app id="app">
    <v-app-bar app clipped-left color="light-blue darken-4" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">SSTS (Sealdah Suburban Tracking System)</v-toolbar-title>
      <v-spacer></v-spacer>

    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <router-view />
      </v-container>
    </v-main>

    <v-footer
  color="primary lighten-1"
  padless
>
  <v-row
    justify="center"
    no-gutters
  >
    <v-btn
    v-for="item in links" :key="item.title" :to="{path: item.path , query: item.query}"
      color="white"
      text
      rounded
      class="my-2"
    >
      {{ item.title }}
    </v-btn>
    <v-col
      class="primary lighten-2 py-4 text-center white--text"
      cols="12"
    >
      {{ new Date().getFullYear() }} — <strong>Electric Operation, Sealdah</strong>
    </v-col>
  </v-row>
</v-footer>
</v-app>
</template>

<script>

export default {
  data: () => ({
      drawer: null,
      links: [
        {
            title: 'Home',
            path: '/',
            icon: 'mdi-home-variant',
            color: "light-blue accent-4",
        },
        {
            title: 'Privacy Policy',
            path: '/privacy',
            icon: 'mdi-home-variant',
            color: "light-blue accent-4",
          },
          {
              title: 'Terms and Conditions',
              path: '/terms',
              icon: 'mdi-home-variant',
              color: "light-blue accent-4",
          },
      ],
    }),
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
